import { Button, Flex, Typography as Typography_Legacy } from 'front-commons/ds';
import { useNavigate } from 'react-router-dom';
import ContactUs from 'containers/ContactUs';
import Head from 'routes/components/Head';
import { ErrorPageProps } from './interface';
import { ErrorContainer } from './styles';
import { Typography } from 'hype-ds';
import NavigationHeader from 'containers/Headers/NavigationHeader';

export default function Error({
	isGlobalBoundary,
	errorType,
	subtitle,
	description,
	showReload,
	showButtonGoToPH = false,
	showHeader = true,
}: ErrorPageProps) {
	const navigate = useNavigate();

	const headTitle = {
		404: 'Página não encontrada',
		500: 'Serviço indisponível',
	};

	return (
		<>
			{errorType && <Head title={headTitle[errorType]} />}

			{showHeader && <NavigationHeader isGlobalBoundary={isGlobalBoundary} />}

			<ErrorContainer>
				<div>
					<Flex
						direction="column"
						gap="0px"
						margin={{ small: '0 0 32px 0', medium: '0 0 24px 0', large: '16px 0 0 0' }}
					>
						{errorType ? (
							<Typography.Heading.L data-font-family="chillax" color="--text-link">
								Erro {errorType}
							</Typography.Heading.L>
						) : (
							<Typography.Heading.L data-font-family="chillax" color="--text-link">
								Página não encontrada
							</Typography.Heading.L>
						)}

						{subtitle && (
							<Typography_Legacy
								as="h2"
								variant={{ small: 'Paragraph/Semibold', medium: 'Subtitle' }}
								color="--text-primary"
							>
								{subtitle}
							</Typography_Legacy>
						)}
					</Flex>

					<Flex direction="column" alignItems="center" gap={{ small: '90px', medium: '24px' }}>
						<div>
							<Flex direction="column" margin={{ small: '0 32px 16px 0', medium: '0 0 24px 0' }}>
								<Typography_Legacy color="--text-primary">{description}</Typography_Legacy>
							</Flex>

							<ContactUs alignItems="center" phoneUnderline phoneColor="--text-link" />
						</div>
						{showReload && (
							<Flex direction="column" gap="16px" alignItems={{ small: 'center', medium: 'flex-start' }}>
								<Typography_Legacy color="--text-primary">Ou recarregue essa página</Typography_Legacy>

								<Button
									size="large"
									onClick={() => navigate(0)}
									width="100%"
									maxWidth={{ small: '260px', medium: '280px' }}
								>
									Tente novamente
								</Button>
							</Flex>
						)}
						{showButtonGoToPH && (
							<Flex direction="column" alignItems={{ small: 'center', medium: 'flex-start' }}>
								<Button
									size="small"
									onClick={() => navigate('/')}
									width="100%"
									maxWidth={{ small: '260px', medium: '280px' }}
								>
									Ir para o Hympar
								</Button>
							</Flex>
						)}
					</Flex>
				</div>
			</ErrorContainer>
		</>
	);
}
